export default "__VITE_ASSET__1d04f1a7__"